import type { ClipUploadImageCompressOptions } from "./types";

export const DEFAULT_COMPRESS: Required<ClipUploadImageCompressOptions> = {
  maxSizeBytes: 5 * 1024 * 1024,
  maxWidthOrHeight: 4096,
  outputType: "image/jpeg",
};

export const DEFAULT_CARD_WIDTH = 135;
export const DEFAULT_CARD_HEIGHT = 180;
export const DEFAULT_GAP = 12;
